import { v4 as uuid } from 'uuid';

function convertToOrderItem(newItem, menu, orderItemId) {
  const menuItem = menu.items.find(i => i.menuItemId === newItem.menuItemId);

  let allMenuItemModifiers = [];

  menuItem.modifierGroups.forEach((group) => {
    allMenuItemModifiers = allMenuItemModifiers.concat(group.modifiers);
  });

  const pricePerItemCents = Math.round(menuItem.price * 100);
  let priceTotalCents = pricePerItemCents * newItem.quantity;
  const modifiers = [];

  newItem.modifiers.forEach((newItemModifier) => {
    const modifier = allMenuItemModifiers.find(m => m.menuItemId === newItemModifier.menuItemId);

    const modifierPricePerItemCents = Math.round(modifier.price * 100);
    const modifierPriceTotalCents = modifierPricePerItemCents * newItemModifier.quantity;
    const modifierPriceTotal = modifierPriceTotalCents / 100;
    priceTotalCents += modifierPriceTotalCents;

    modifiers.push({
      menuItemId: modifier.menuItemId,
      itemDescription: modifier.description,
      quantity: newItemModifier.quantity,
      priceTotal: modifierPriceTotal
    });
  });

  const orderItem = {
    categoryId: newItem.categoryId,
    menuItemId: menuItem.menuItemId,
    isUpsell: newItem.isUpsell,
    itemDescription: menuItem.description,
    modifiers,
    orderItemId: orderItemId || uuid(),
    priceTotal: priceTotalCents / 100,
    quantity: newItem.quantity,
    specialInstructions: newItem.specialInstructions
  };

  return orderItem;
}



export default convertToOrderItem;
